import React, { useState } from 'react';
import { X, Download, Smartphone, Star, Heart, Users, MapPin } from 'lucide-react';
import '../styles/AppDownloadBanner.css';

const AppDownloadBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="app-download-banner">
      <div className="banner-content">
        <div className="banner-left">
          <div className="app-icon">
            <Smartphone size={32} />
          </div>
          <div className="banner-text">
            <h3>Get the VibrantCast App!</h3>
            <p>Discover art near you, connect with artists, and explore exhibitions</p>
            <div className="feature-highlights">
              <span className="feature-tag">
                <MapPin size={14} />
                Local Art Discovery
              </span>
              <span className="feature-tag">
                <Heart size={14} />
                Artist Connections
              </span>
              <span className="feature-tag">
                <Users size={14} />
                Community
              </span>
            </div>
          </div>
        </div>
        
        <div className="banner-actions">
          <div className="app-store-buttons">
            <a 
              href="https://apps.apple.com/us/app/vibrantcast/id6569221167" 
              target="_blank" 
              rel="noopener noreferrer"
              className="app-store-btn apple-store"
            >
              <img 
                src="/images/apple.png" 
                alt="Download on the App Store"
                className="app-store-badge"
              />
            </a>
            <a 
              href="https://play.google.com/store/apps/details?id=com.mycompany.vibrantcast" 
              target="_blank" 
              rel="noopener noreferrer"
              className="app-store-btn google-play"
            >
              <img 
                src="/images/google.png" 
                alt="Get it on Google Play"
                className="app-store-badge"
              />
            </a>
          </div>
          <button 
            className="close-banner-btn"
            onClick={() => setIsVisible(false)}
          >
            <X size={20} color="#ffffff" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppDownloadBanner;
